import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import { Grid, Row, Col } from 'react-flexbox-grid';
import accountRules from '../../../common/rules/accountRules';

const { Item: FormItem } = Form;

@translate()
@Form.create()
export default class ResetPasswordForm extends Component {
  static propTypes = {
    form: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    passwordResetToken: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
  };

  state = {
    repeatPasswordDirty: false,
  };

  handleSubmit = e => {
    e.preventDefault();

    const { form, onSubmit, passwordResetToken } = this.props;

    form.validateFields((err, values) => {
      if (!err) {
        onSubmit({ email: values.email, password: values.password, token: passwordResetToken });
      }
    });
  };

  handleRepeatPasswordBlur = e => {
    const { repeatPasswordDirty } = this.state;

    this.setState({ repeatPasswordDirty: repeatPasswordDirty || !!e.target.value });
  };

  render() {
    const { form, t } = this.props;
    const { getFieldDecorator } = form;
    const { repeatPasswordDirty } = this.state;

    return (
      <Grid className="auth-wrapper">
        <Row around="xs">
          <Col xs={12} sm={6}>
            <h2>{t('Reset hesla')}</h2>
            <Form layout="vertical" onSubmit={this.handleSubmit} hideRequiredMark>
              <FormItem label={t('E-mail')}>
                {getFieldDecorator('email', { rules: accountRules.email })(
                  <Input size="default" placeholder={t('E-mail')} type="email" autoFocus />
                )}
              </FormItem>
              <FormItem label={t('Heslo')}>
                {getFieldDecorator('password', {
                  rules: [
                    ...accountRules.passwordWithLimit,
                    {
                      validator: accountRules.checkRepeatPassword(form, repeatPasswordDirty),
                    },
                  ],
                })(<Input size="default" type="password" placeholder={t('Heslo')} />)}
              </FormItem>
              <FormItem>
                {getFieldDecorator('repeatPassword', {
                  rules: [
                    ...accountRules.passwordWithLimit,
                    {
                      validator: accountRules.checkPassword(form),
                    },
                  ],
                })(
                  <Input
                    size="default"
                    type="password"
                    placeholder={t('Zopakovať heslo')}
                    onBlur={this.handleRepeatPasswordBlur}
                  />
                )}
              </FormItem>
              <Row between="xs" middle="xs" className="form-actions">
                <Col xs={12} sm={6}>
                  <Button type="primary" htmlType="submit" size="default">
                    {t('Prihlásiť')}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/auth/components/ResetPasswordForm.js